<ll-titulo>Editar Sesion</ll-titulo>

<sesiones-edit [sesionId]="sesionId" [id]="id"></sesiones-edit>
